<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <p>设置</p>
      </div>
      <div class="main">
        <button class="return" @click="goback"><img src="@/assets/images/left-arrow.png" alt=""></button>
        <div class="main-content">
          <button @click="navigateToSBSTokenManagement">后台管理1</button>
          <button @click="goAdminPage">后台管理2</button>
          <!-- <button @click="goAdminPages">后台管理3</button> -->
          <button @click="navigateTotornadoCoinManagement">Tornado代币管理</button>


          <!-- 任何人充值SBS -->
          <div style="margin-top:20px;">
            <label for="sbsDepositAmount">SBS充值金额：</label>
            <input type="number" id="sbsDepositAmount" v-model="sbsDepositAmount" placeholder="请输入充值金额 (SBS)" />
            <button @click="depositSBSWithApprove">一键充值SBS</button>
            <p>合约SBS余额：{{ contractSBSTokenBalance }} SBS</p>
          </div>

          <template v-if="isOwner">
            <div style="margin-top:20px;">
              <label for="batchSize">批次大小：</label>
              <input type="number" id="batchSize" v-model="batchSize" placeholder="请输入批次大小" />

              <label for="settleRoundId">结算轮ID(新轮填新数字)：</label>
              <input type="number" id="settleRoundId" v-model="settleRoundId" placeholder="结算轮ID，必须>0"/>
              <p style="font-size:12px;color:#666;">💡本地记忆：当前轮ID={{ settleRoundId }}</p>

              <button @click="calculateDividends">计算分红</button>
              <button @click="handleResetBatch">重置批次索引</button>
              <button style="color:red;margin-left:8px;" @click="handleForceReset">⚠️故障强制重置(分片卡死用)</button>

              <p>当前结算游标：{{ nowBatchIndex }}</p>
              <p>未结算会员人数：{{ unsettledMembersCount }}</p>
              <p>拨出的总SBS：{{ totalDividendsDistributed }} SBS</p>
              <p>钱包内SBS余额：{{ walletSBSTokenBalance }} SBS</p>
            </div>

            <div style="margin-top:20px;">
              <label for="sbsRecipientAddress">SBS接收地址：</label>
              <input type="text" id="sbsRecipientAddress" v-model="sbsRecipientAddress" placeholder="请输入SBS接收地址" />
              <label for="sbsTransferAmount">SBS转账金额：</label>
              <input type="number" id="sbsTransferAmount" v-model="sbsTransferAmount" placeholder="请输入SBS转账金额" />
              <button @click="transferSBSToken">转账SBS</button>
            </div>

            <div style="margin-top:20px;">
              <label for="oneMachineDividendRate">1号矿机分红比例：</label>
              <input type="number" id="oneMachineDividendRate" v-model="oneMachineDividendRate" placeholder="比例" />
              <button @click="setOneMachineDividendRate">设置1号矿机比例</button>

              <label for="twoMachineDividendRate">2号矿机分红比例：</label>
              <input type="number" id="twoMachineDividendRate" v-model="twoMachineDividendRate" placeholder="比例" />
              <button @click="setTwoMachineDividendRate">设置2号矿机比例</button>

              <label for="threeMachineDividendRate">3号矿机分红比例：</label>
              <input type="number" id="threeMachineDividendRate" v-model="threeMachineDividendRate" placeholder="比例" />
              <button @click="setThreeMachineDividendRate">设置3号矿机比例</button>
            </div>

            <div style="margin-top:24px; padding-top:16px; border-top:1px solid #eee;">
              <label for="firstLevelBonusRate">1代推荐奖金比例：</label>
              <input type="number" id="firstLevelBonusRate" v-model="firstLevelBonusRate" placeholder="%" />
              <button @click="setFirstLevelBonusRate">设置1代奖金</button>

              <label for="secondLevelBonusRate">2代推荐奖金比例：</label>
              <input type="number" id="secondLevelBonusRate" v-model="secondLevelBonusRate" placeholder="%" />
              <button @click="setSecondLevelBonusRate">设置2代奖金</button>

              <label for="otherLevelsBonusRate">3~10代推荐奖金比例：</label>
              <input type="number" id="otherLevelsBonusRate" v-model="otherLevelsBonusRate" placeholder="%" />
              <button @click="setOtherLevelsBonusRate">设置3~10代奖金</button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-empty */
import { ethers } from 'ethers';
import { contractAddress, contractABI, sbsTokenAddress, sbsTokenABI } from '@/js/contract.js';

export default {
  name: 'settings',
  data() {
    return {
      recipientAddress: '',
      isOwner: false,
      totalDividendsDistributed: '0',
      sbsRecipientAddress: '',
      sbsTransferAmount: '',
      sbsDepositAmount: '',
      contractSBSTokenBalance: '0',
      walletSBSTokenBalance: '0',
      provider: null,
      signer: null,
      contract: null,
      sbsTokenContract: null,
      oneMachineDividendRate: '',
      twoMachineDividendRate: '',
      threeMachineDividendRate: '',

      firstLevelBonusRate: '',
      secondLevelBonusRate: '',
      otherLevelsBonusRate: '',

      batchSize: '',
      settleRoundId: '',
      unsettledMembersCount: 0,
      nowBatchIndex: 0
    };
  },
  mounted() {
    // 页面加载从localStorage读取上次保存的roundId
    const savedRound = localStorage.getItem('settleRoundId');
    if(savedRound && Number(savedRound) > 0){
      this.settleRoundId = Number(savedRound);
    }
    this.initializeContract();
  },
  watch:{
    // 用户手动修改输入框时，同步保存到本地存储
    settleRoundId(val){
      if(val && Number(val) > 0){
        localStorage.setItem('settleRoundId', String(val));
      }
    }
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    navigateToSBSTokenManagement() {
      this.$router.push({ name: 'SbsToken' });
    },
    navigateTotornadoCoinManagement() {
      this.$router.push({ name: 'tornadoCoin' });
    },
    goAdminPage() {
      this.$router.push({ name: 'admins' });
    },
    goAdminPages() {
      this.$router.push({ name: 'adminss' });
    },
    async initializeContract() {
      await this.connectWallet();
      await this.checkOwnership();
      await this.getContractSBSTokenBalance();
      await this.getWalletSBSTokenBalance();

      if (this.isOwner) {
        await this.getTotalDividendsDistributed();
        await this.getUnsettledMembersCount();
        await this.getNowBatchIndex();
        await this.loadCurrentBonusRates();
        await this.loadMachineDividendRates();
      }
    },
    // 获取当前结算游标
    async getNowBatchIndex() {
      try {
        let idx = await this.contract.batchIndex();
        this.nowBatchIndex = Number(idx.toString());
      } catch (e) {
        console.error(e)
      }
    },

    async loadCurrentBonusRates() {
      try {
        let r1 = await this.contract.firstLevelBonusRate();
        let r2 = await this.contract.secondLevelBonusRate();
        let ro = await this.contract.otherLevelsBonusRate();
        this.firstLevelBonusRate = r1.toString();
        this.secondLevelBonusRate = r2.toString();
        this.otherLevelsBonusRate = ro.toString();
      } catch (e) {
        console.error("加载奖金比例失败", e);
      }
    },

    async loadMachineDividendRates() {
      try {
        let rate1 = await this.contract.oneMachineDividendRate();
        let rate2 = await this.contract.twoMachineDividendRate();
        let rate3 = await this.contract.threeMachineDividendRate();

        this.oneMachineDividendRate = (Number(rate1) / 1000000).toFixed(6);
        this.twoMachineDividendRate = (Number(rate2) / 1000000).toFixed(6);
        this.threeMachineDividendRate = (Number(rate3) / 1000000).toFixed(6);
      } catch (e) {
        console.error("加载矿机分红比例失败", e);
      }
    },

    async connectWallet() {
      try {
        if (typeof window.ethereum !== 'undefined') {
          this.provider = new ethers.providers.Web3Provider(window.ethereum);
          await this.provider.send("eth_requestAccounts", []);
          this.signer = this.provider.getSigner();
          this.contract = new ethers.Contract(contractAddress, contractABI, this.signer);
          this.sbsTokenContract = new ethers.Contract(sbsTokenAddress, sbsTokenABI, this.signer);
        } else {
          alert('请安装MetaMask钱包');
        }
      } catch (error) {
        console.error('连接钱包失败:', error);
      }
    },

    async checkOwnership() {
      try {
        const currentAccount = await this.signer.getAddress();
        const ownerAddress = await this.contract.owner();
        this.isOwner = currentAccount.toLowerCase() === ownerAddress.toLowerCase();
      } catch (error) {
        console.error(error);
        this.isOwner = false;
      }
    },

    async getTotalDividendsDistributed() {
      try {
        const total = await this.contract.viewTotalDividendsDistributed();
        this.totalDividendsDistributed = ethers.utils.formatUnits(total, 6);
      } catch (error) {
        console.error(error);
      }
    },

    // 调用合约原生精准未结算人数接口
    async getUnsettledMembersCount() {
      try {
        const c = await this.contract.getUnsettledMembersCount();
        this.unsettledMembersCount = Number(c.toString());
      } catch (e) {
        this.unsettledMembersCount = 0
        console.error("获取未结算人数失败", e)
      }
    },

    async calculateDividends() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!this.batchSize || Number(this.batchSize) <= 0) {
        alert('请输入有效批次大小'); return;
      }
      if (!this.settleRoundId || Number(this.settleRoundId) <= 0) {
        alert('结算轮ID必须大于0'); return;
      }
      try {
        const batchNum = Number(this.batchSize)
        const roundId = Number(this.settleRoundId)
        const tx = await this.contract.calculateDividends(batchNum, roundId);
        await tx.wait();
        alert('当前批次分红计算完成');
        await this.refreshStatus();
      } catch (e) {
        alert('失败：' + (e.message || JSON.stringify(e)));
        console.error(e);
      }
    },

    async handleResetBatch(){
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      // 前端防护：未结算人数>0禁止执行普通重置
      if(Number(this.unsettledMembersCount) > 0){
        alert("分片尚未全部跑完，请不要调用resetBatchIndex！异常请使用forceResetBatchIndex");
        return;
      }
      try {
        const tx = await this.contract.resetBatchIndex();
        await tx.wait();
        alert('重置批次游标成功，轮ID自动+1开启下一轮！');
        let newId = Number(this.settleRoundId || 0) + 1;
        this.settleRoundId = newId;
        localStorage.setItem('settleRoundId', String(newId));
        this.batchSize = '';
        await this.refreshStatus();
      } catch (e) {
        alert('重置失败：' + (e.message || JSON.stringify(e)));
        console.error(e);
      }
    },

    async handleForceReset(){
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if(!confirm("确认执行【故障强制重置】？该操作会直接清空batchIndex、roundId、时间戳，仅分片卡死时使用！")){
        return;
      }
      try {
        const tx = await this.contract.forceResetBatchIndex();
        await tx.wait();
        alert('故障强制重置完成！轮ID自动+1');
        let newId = Number(this.settleRoundId || 0) + 1;
        this.settleRoundId = newId;
        localStorage.setItem('settleRoundId', String(newId));
        this.batchSize = '';
        await this.refreshStatus();
      } catch (e) {
        alert('强制重置失败：' + (e.message || JSON.stringify(e)));
        console.error(e);
      }
    },

    // 统一刷新状态接口
    async refreshStatus(){
      await this.getNowBatchIndex();
      await this.getUnsettledMembersCount();
      await this.getTotalDividendsDistributed();
    },

    async depositSBSWithApprove() {
      if (!this.sbsDepositAmount) return alert('请输入充值金额');
      try {
        const amt = ethers.utils.parseUnits(this.sbsDepositAmount, 6);
        alert('正在进行授权，请确认交易...');
        const txApprove = await this.sbsTokenContract.approve(contractAddress, amt);
        await txApprove.wait();
        alert('授权成功，正在充值...');
        const txDeposit = await this.contract.depositSBS(amt);
        await txDeposit.wait();
        alert('SBS 充值成功！');
        await this.getContractSBSTokenBalance();
        await this.getWalletSBSTokenBalance();
      } catch (e) {
        alert('操作失败：' + e.message);
      }
    },

    async getContractSBSTokenBalance() {
      try {
        const bal = await this.sbsTokenContract.balanceOf(contractAddress);
        this.contractSBSTokenBalance = parseFloat(ethers.utils.formatUnits(bal, 6)).toFixed(2);
      } catch (e) { }
    },

    async transferSBSToken() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!this.sbsRecipientAddress || !this.sbsTransferAmount) return alert('信息不完整');
      try {
        const amt = ethers.utils.parseUnits(this.sbsTransferAmount, 6);
        const tx = await this.contract.transferSBSToken(this.sbsRecipientAddress, amt);
        await tx.wait();
        alert('转账成功');
        await this.getContractSBSTokenBalance();
      } catch (e) {
        alert('失败：' + e.message);
      }
    },

    async getWalletSBSTokenBalance() {
      try {
        const addr = await this.signer.getAddress();
        const bal = await this.sbsTokenContract.balanceOf(addr);
        this.walletSBSTokenBalance = parseFloat(ethers.utils.formatUnits(bal, 6)).toFixed(2);
      } catch (e) { }
    },

    toPPM(rate) {
      return parseInt(parseFloat(rate) * 1000000);
    },

    async setOneMachineDividendRate() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!this.oneMachineDividendRate) return alert('输入比例');
      try {
        const tx = await this.contract.setOneMachineDividendRate(this.toPPM(this.oneMachineDividendRate));
        await tx.wait();
        alert('设置成功');
        await this.loadMachineDividendRates();
      } catch (e) { alert('失败：' + e.message); }
    },

    async setTwoMachineDividendRate() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!this.twoMachineDividendRate) return alert('输入比例');
      try {
        const tx = await this.contract.setTwoMachineDividendRate(this.toPPM(this.twoMachineDividendRate));
        await tx.wait();
        alert('设置成功');
        await this.loadMachineDividendRates();
      } catch (e) { alert('失败：' + e.message); }
    },

    async setThreeMachineDividendRate() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!this.threeMachineDividendRate) return alert('输入比例');
      try {
        const tx = await this.contract.setThreeMachineDividendRate(this.toPPM(this.threeMachineDividendRate));
        await tx.wait();
        alert('设置成功');
        await this.loadMachineDividendRates();
      } catch (e) { alert('失败：' + e.message); }
    },

    async setFirstLevelBonusRate() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      try {
        const tx = await this.contract.setFirstLevelBonusRate(Number(this.firstLevelBonusRate));
        await tx.wait();
        alert('1代奖金设置成功！');
      } catch (e) { alert('失败：' + e.message); }
    },

    async setSecondLevelBonusRate() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      try {
        const tx = await this.contract.setSecondLevelBonusRate(Number(this.secondLevelBonusRate));
        await tx.wait();
        alert('2代奖金设置成功！');
      } catch (e) { alert('失败：' + e.message); }
    },

    async setOtherLevelsBonusRate() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      try {
        const tx = await this.contract.setOtherLevelsBonusRate(Number(this.otherLevelsBonusRate));
        await tx.wait();
        alert('3~10代奖金设置成功！');
      } catch (e) { alert('失败：' + e.message); }
    }
  }
}
</script>

<style scoped>
@import "@/assets/css/settings.css";
@import "@/assets/css/style.css";

.main {
  padding-top: 50px;
}
</style>
